import { render } from "./App.vue?vue&type=template&id=628fa39d&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=628fa39d&scoped=true&lang=css"
import "./App.vue?vue&type=style&index=1&id=628fa39d&lang=css"

import exportComponent from "/Users/ts/Desktop/works/vue3_portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628fa39d"]])

export default __exports__